<template>
  <div>
    <div v-for="장비유형 in form.장비유형.선택.filter((value) => value !== '기타')" :key="장비유형" class="avoid-page-break">
      <div class="flex">
        <svg width="151" height="32" viewBox="0 0 151 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_36360_226064)">
            <path d="M63.3511 24.3108C60.2369 24.3108 58.3775 23.5472 58.3775 22.8177C58.3775 21.8788 60.4251 21.2171 63.3511 21.2171C66.2771 21.2171 68.416 21.8732 68.416 22.8177C68.416 23.5529 66.5224 24.3108 63.3511 24.3108ZM63.3511 18.2422C57.5162 18.2422 54.0312 19.9332 54.0312 22.7668C54.0312 25.6003 57.6246 27.2913 63.4081 27.2913C69.1917 27.2913 72.7565 25.5154 72.7565 22.7668C72.7565 20.0181 69.1518 18.2422 63.3454 18.2422" fill="#002452"/>
            <path d="M96.4269 4.87145V4.71875H78.3519V7.67103H92.2005C92.2062 8.97184 91.9723 11.63 91.6415 12.8799H76.5039V15.8322H85.1108V18.53H77.8728V21.5105H92.1092V27.285H96.3357V18.53H89.3657V15.8322H97.9726V12.8799H95.7311C96.233 10.94 96.4897 7.77849 96.4269 4.87145Z" fill="#002452"/>
            <path d="M138.56 24.3084C135.52 24.3084 133.706 23.6071 133.706 22.4307C133.706 21.2543 135.566 20.5813 138.56 20.5813C141.555 20.5813 143.505 21.2883 143.505 22.4307C143.505 23.5732 141.657 24.3084 138.56 24.3084ZM138.56 17.5781C132.902 17.5781 129.389 19.4389 129.389 22.4307C129.389 25.4226 132.817 27.2833 138.56 27.2833C144.304 27.2833 147.852 25.4678 147.852 22.4307C147.852 19.3936 144.292 17.5781 138.56 17.5781Z" fill="#002452"/>
            <path d="M140.261 6.00386V5.83984H127.376V8.89393H135.498C134.888 11.6935 131.18 14.2782 126.623 15.0643L126.406 15.1039L128.083 18.0618L128.197 18.0392C135.937 16.2237 139.998 12.1742 140.261 6.00386Z" fill="#002452"/>
            <path d="M123.388 4.16406H119.869V27.2903H123.388V4.16406Z" fill="#002452"/>
            <path d="M114.992 11.8393H111.992V15.0687H114.992V26.5894H118.506V4.71875H114.992V11.8393Z" fill="#002452"/>
            <path d="M108.925 9.57436V8.76559H113.105V5.83594H101.048V8.76559H105.229V9.57436C105.229 13.4598 104.344 16.5705 100.027 19.0929L99.8613 19.1891L102.171 21.6889L102.206 21.7285L102.314 21.6776C104.036 20.8292 106.147 18.6574 107.077 16.7854C108.006 18.6574 110.117 20.8292 111.839 21.6776L111.942 21.7285L114.286 19.1891L114.121 19.0929C109.803 16.5648 108.919 13.4598 108.919 9.57436" fill="#002452"/>
            <path d="M143.271 4.16406V17.2118H147.498V12.3762H150.487V9.14674H147.498V4.16406H143.271Z" fill="#002452"/>
            <path d="M65.5694 14.196V12.8047H72.5793V9.85238H58.6394V7.72584H72.5736V4.72266H54.413V12.8047H61.3145V14.196H52.6562V17.1482H74.1307V14.196H65.5694Z" fill="#002452"/>
            <path d="M44.6034 4.72266H36.5498L25.5645 16.8146L35.0668 27.2776H43.1204L33.6181 16.8146L44.6034 4.72266Z" fill="#002452"/>
            <path d="M11.7715 32.0015H19.2947L27.8103 22.63L24.0459 18.4844L11.7715 32.0015Z" fill="#C51F2A"/>
            <path d="M30.2704 0L20.2832 10.9947L24.0419 15.1347L37.7936 0H30.2704Z" fill="#C51F2A"/>
            <path d="M19.1873 14.0924C19.1701 13.9793 19.1473 13.8662 19.1245 13.7531C18.9534 12.9273 18.6853 12.1355 18.3431 11.3833C18.2918 11.2702 18.2404 11.1571 18.1834 11.044C16.3297 7.33384 12.4797 4.77181 8.12207 4.72656H5.94326H0V11.044H8.1734C8.81222 11.044 9.42252 11.1684 9.98148 11.3833C11.1279 11.8245 12.069 12.6728 12.6223 13.7531C12.6793 13.8662 12.7364 13.9793 12.782 14.0924C13.0273 14.6806 13.1641 15.3197 13.1641 15.9927C13.1641 18.0967 11.8409 19.8839 9.97577 20.6021C9.41681 20.8171 8.80652 20.9415 8.1677 20.9415H5.59533V14.0868H0.0114074L0 27.2702H8.37874C12.6337 27.1288 16.3696 24.5838 18.1891 20.9415C18.2461 20.8284 18.2975 20.7153 18.3488 20.6021C18.9933 19.1939 19.3527 17.6385 19.3527 15.9984C19.3527 15.348 19.2956 14.7089 19.1873 14.0868" fill="#002452"/>
          </g>
          <defs>
            <clipPath id="clip0_36360_226064">
              <rect width="150.486" height="32" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        <h1 class="flex-1 text-center" style="font-weight: 700; font-size:32px;">일 장비사용계획서(외부작업)</h1>
        <div class="flex justify-end">
          <div style="margin-right:20px; font-weight: 500; font-size:15px;">[승인/확인용 QR]</div>
          <div style="width: 82px; height: 82px; padding: 2px; border: 1px solid #333;" class="flex justify-center items-center">
            <img :src="`${BASE_API_URL}/api/v1/qr/generate?code=${currentUrl}&size=200&padding=1`" width="76" alt="QR Code" />
          </div>
        </div>
      </div>

      <ul class="options black">
        <li class="col-span-2"><h5>■ 일 안전작업허가번호: </h5>{{ form.작업정보.허가번호 }}</li>
        <li>
          <h5>■ 허가 신청자: </h5>
          <h5>팀(업체): </h5><span style="min-width: 40px; margin:0 4px;">{{form.stdInfo.section}}</span>
          <h5>직책: </h5><span style="min-width: 40px; margin:0 4px;">{{form.stdInfo.rank}}</span>
          <h5>성명: </h5><span style="min-width: 40px; margin:0 4px;">{{form.stdInfo.writer_name}}</span>
        </li>
        <li><h5>■ 허가승인: </h5>{{new Date(form.작업허가.작업승인.승인일시).format('yyyy년 MM월 dd일 HH:mm')}}</li>
        <li><h5>■ 허가신청기간: </h5>{{new Date(form.작업허가.작업시작일시).format('yyyy년 MM월 dd일')}}
          {{ form.작업허가.작업시간.시작 }}~{{ form.작업허가.작업시간.종료 }}</li>
        <li>
          <h5>■ 허가 승인자: </h5>
          <h5>팀(업체): </h5><span style="min-width: 40px; margin:0 4px;">{{ form.작업허가.작업승인.승인자.부서 }}</span>
          <h5>직책: </h5><span style="min-width: 40px; margin:0 4px;">{{ form.작업허가.작업승인.승인자.직책 }}</span>
          <h5>성명: </h5><span style="min-width: 40px; margin:0 4px;">{{ form.작업허가.작업승인.승인자.성명 }}</span>
          <div style="color:#9CA0A4; font-size:14px; font-weight: 500;">(서명)</div>
        </li>
        <li><h5>■ 작업완료시간: </h5>{{ new Date(form.작업허가.작업종료.승인일시).format('yyyy년 MM월 dd일 HH:mm') }}</li>
        <li>
          <h5>■ 확인자(안전환경팀, 필요시): </h5>
          <h5>팀(업체): </h5><span style="min-width: 40px; margin:0 4px;">{{form.안전관계자.확인자.section}}</span>
          <h5>직책: </h5><span style="min-width: 40px; margin:0 4px;">{{form.안전관계자.확인자.rank}}</span>
          <h5>성명: </h5><span style="min-width: 40px; margin:0 4px;">{{form.안전관계자.확인자.name}}</span>
          <div style="color:#9CA0A4; font-size:14px; font-weight: 500; position: relative">
            (서명)
            <img v-if="form.안전관계자.확인자서명.sign" :src="form.안전관계자.확인자서명.sign" style="position: absolute; inset:50%; width:100px; transform: translate(-50%, -50%);">
          </div>
        </li>
      </ul>

      <template v-for="장비 in [form.장비유형[장비유형]]">
        <ul class="options blue">
          <li class="col-span-2"><h5>■ 장비번호(차량번호): </h5>{{장비.장비번호 || 장비.차량번호}}</li>
          <li><h5>■ 작업 내용: </h5>{{form.작업정보.작업내용}}</li>
          <li><h5>■ 작업 장소: </h5>{{form.작업정보.작업구역.region.name}} {{form.작업정보.작업구역.zone.name}}</li>
          <li><h5>■ 업체 안전전담자: </h5>{{form.안전관계자.동국제강.name}}</li>
          <li><h5>■ 작업 인원수: </h5>{{form.안전관계자.공사업체.length}}명</li>
          <li class="col-span-2 gap-2">
            <h5>■ 장비유형: </h5>
            <span v-for="유형 in form.장비유형.유형"
                  class="flex items-center gap-2"><print-checkbox :value="form.장비유형.선택.includes(유형)"/>{{ 유형 }}</span>
          </li>
        </ul>

        <p style="margin-top: 17px; font-weight: 700; font-size: 17px">◇{{장비유형}} ({{장비.중량}})톤</p>
        <!-- 점검사항 -->
        <table class="w-full">
          <colgroup>
            <col width=""/>
            <col width="50"/>
            <col width="50"/>
            <col width="254"/>
          </colgroup>
          <thead>
            <tr>
              <th rowspan="2">점검사항</th>
              <th colspan="2">점검결과</th>
              <th rowspan="2">점검 Point</th>
            </tr>
            <tr>
              <th>양호</th>
              <th>불량</th>
            </tr>
            <template v-for="(item, item_i) in 장비.inspectList">
              <tr v-if="item.title && (item_i === 0 || 장비.inspectList[item_i].title !== 장비.inspectList[item_i - 1].title)">
                <th class="text-left" colspan="3">{{ item.title }}</th>
                <td v-if="item_i === 0" :rowspan="장비.inspectList.length + getHeads(장비.inspectList)" class="p-0">
                  <div v-for="(imgName, img_i) in getImages(장비유형)" :key="`장비_${imgName}`"
                       class="flex justify-center p-2"
                       :class="[ getImages(장비유형).length > img_i +1 ? 'border-bottom' : '' ]"
                       style="max-height:100px;"
                  >
                    <img :src="require(`@/assets/images/장비/${imgName}.png`)" style="width: 100%; height:auto; object-fit: contain;">
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="flex items-center">
                    <span style="width: 20px;">{{item_i + 1}}</span>
                    <div class="flex-1" colspan="3" v-html="item.content"></div>
                  </div>
                </td>
                <td><div class="flex justify-center">
                  <PrintCheckbox :value="item.isChecked === '양호'" />
                </div></td>
                <td><div class="flex justify-center">
                  <PrintCheckbox :value="item.isChecked === '불량'" />
                </div></td>
              </tr>
            </template>
          </thead>
        </table>

        <table class="w-full mt-1">
          <tr>
            <th>구분</th>
            <th>소속</th>
            <th>성명</th>
            <th>서명</th>
            <th>점검상태</th>
          </tr>
          <tr>
            <th>점검자(운전자)</th>
            <td class="text-center">{{ 장비.점검자 && 장비.점검자.department }}</td>
            <td class="text-center">{{ 장비.점검자 && 장비.점검자.name }}</td>
            <td><img v-if="장비.점검자서명" :src="장비.점검자서명" style="margin-left:auto; margin-right:auto; width: auto; height: 50px; object-fit: contain"></td>
            <td class="text-center">{{ 장비.점검상태 }}</td>
          </tr>
          <tr>
            <th>확인자(사용주체)</th>
            <td class="text-center">{{ 장비.확인자 && 장비.확인자.department }}</td>
            <td class="text-center">{{ 장비.확인자 && 장비.확인자.name }}</td>
            <td><img v-if="장비.확인자서명" :src="장비.확인자서명" style="margin-left:auto; margin-right:auto; width: auto; height: 50px; object-fit: contain"></td>
            <td class="text-center">{{ 장비.확인상태 }}</td>
          </tr>
        </table>

        <table class="w-full mt-1">
          <colgroup>
            <col width="100" />
            <col width="" />
          </colgroup>
          <tr>
            <th>{{ 장비유형 }}<br>구조</th>
            <td>
              <div class="w-full grid items-start" style="grid-template-columns: 1fr 398px;">
                <div class="w-full">
                  <img v-if="getData(장비유형).img"
                       :src="require(`@/assets/images/장비/${getData(장비유형).img}`)"
                       style="width: 100%; height:auto; object-fit: contain;"
                       :style="{maxHeight: 장비유형 === '이동식크레인'? '248px': '300px'}"
                  />
                </div>
                <table class="w-full">
                  <tr><th colspan="2">장비점검 유효기간</th></tr>
                  <tr v-for="(head, h_i) in getData(장비유형).headers">
                    <th v-html="head"></th>
                    <td>{{ 장비[getData(장비유형).valueKeys[h_i]] }}</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </table>
      </template>
    </div>

  </div>
</template>

<script>
import VueQRCodeComponent from "vue-qrcode-component";
import config from "../../../../../public/config";
import PrintRadio from "@/components/print/PrintRadio.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import {req} from "vuelidate/lib/validators/common";
export default {
  name: "Print",
  props: {
    form: Object,
    projectId: [String, Number],
    boardId: [String, Number],
    postId: [String, Number],
  },
  components: {
    PrintCheckbox,
    PrintRadio,
    VueQRCodeComponent,
  },
  computed: {
    BASE_URL() {
      return config.BASE_URL;
    },
    BASE_API_URL() {
      return config.BASE_API_URL;
    },
    currentUrl() {
      return `${this.BASE_URL}/project/${this.projectId}/tab/${this.boardId}/write/${this.postId}`;
    },
  },
  methods: {
    req,
    getHeads (list) {
      let i=0;
      list.map((item, index) => {
        if (item.title && (index === 0 || list[index].title !== list[index - 1].title)) i++;
      });
      return i;
    },

    getData (장비유형) {
      const images = {
        "지게차": '1.png',
        "이동식크레인": '2.png',
        "고소작업차": '3.png',
        "고소작업대": '4.png',
        "굴삭기": '',
        "기타": '',
      }
      const headers = {
        "지게차": ['차량소속', '차량번호', '정격하중', '제조년도', '비고'],
        "이동식크레인": ['차량소속', '차량번호', '정격하중', '제조년도', '인증여부<span>(2009.10 이후 출고 차량)</span>', '비고'],
        "고소작업차": ['차량소속', '차량번호', '정격하중', '제조년도', '인증여부<span>(2009.07 이후 출고 차량 필수)</span>', '비고'],
        "고소작업대": ['차량소속', '차량번호', '정격하중', '제조년도', '인증여부<span>(2009.07 이후 출고 차량 필수)</span>', '비고'],
        "굴삭기": ['차량소속', '차량번호', '정격하중', '제조년도', '비고'],
        "기타": [],
      }

      const valueKeys = {
        "지게차": ['차량소속', '차량번호', '정격하중', '제조년도', '비고'],
        "이동식크레인": ['차량소속', '차량번호', '정격하중', '제조년도', '인증여부', '비고'],
        "고소작업차": ['차량소속', '차량번호', '정격하중', '제조년도', '인증여부', '비고'],
        "고소작업대": ['차량소속', '차량번호', '정격하중', '제조년도', '인증여부', '비고'],
        "굴삭기": ['차량소속', '차량번호', '정격하중', '제조년도', '인증여부', '비고'],
        "기타": [],
      }
      return {
        headers: headers[장비유형],
        valueKeys: valueKeys[장비유형],
        img: images[장비유형]
      }
    },
    getImages (장비유형) {
      const images = {
        "지게차": ["1-1", "1-2", "1-3", "1-4", "1-5", "1-6"],
        "이동식크레인": ["2-1", "2-2", "2-3", "2-4", "2-5", "2-6"],
        "고소작업차": ["3-1", "3-2", "3-3", "3-4", "3-5", "3-6"],
        "고소작업대": ["4-1", "4-2", "4-3", "4-4", "4-5"],
        "굴삭기": [],
        "기타": [],
      }

      return images[장비유형]
    }
  }
}
</script>

<style scoped lang="scss">
.options {
  display: grid;
  gap-columns: 10px;
  grid-template-columns: 45fr 55fr;

  &.black > li { color: #3C3C3C; h5 { color: #3C3C3C; }; }
  &.blue > li { color:#4839EB; h5 { color:#4839EB; } }
  li {
    padding: 4px 0;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 400;
  }
  h5 {
    font-weight: 700;
    font-size: 14px;
    margin-left: 4px;
    margin-right: 4px;

    &.first { margin-left: 0; }
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
  th,
  td {
    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }
  th {
    background-color: #ECECEC;
    font-weight: 700;
    text-align: center;
  }
  td {
    padding: 7px;
  }
}

@media print {
  .avoid-page-break {
    page-break-inside: avoid; /* 한 페이지 안에 유지 */
    page-break-before: always;
    page-break-after: auto;
  }
}

</style>
